export default __webpack_public_path__ + "static/avatar-kortical-team2-b149da17986f738699e8d06085a8b5ad.jpg";